"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adEvents_1 = require("../../lib/sports/football/adEvents");
const adEvents_2 = require("../../lib/sports/rugbyLeague/adEvents");
const adEvents_3 = require("../../lib/sports/cricket/adEvents");
const adEvents_4 = require("../sports/rugbyUnion/adEvents");
exports.sportAdEvents = {
    football: adEvents_1.footballAdEvents,
    cricket: adEvents_3.cricketAdEvents,
    rugbyLeague: adEvents_2.rugbyLeagueAdEvents,
    rugbyUnion: adEvents_4.rugbyUnionAdEvents
};
//# sourceMappingURL=AdEvents.js.map